/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationSubscribeObject } from './IntegrationSubscribeObject';
import {
    IntegrationSubscribeObjectFromJSON,
    IntegrationSubscribeObjectFromJSONTyped,
    IntegrationSubscribeObjectToJSON,
} from './IntegrationSubscribeObject';

/**
 * 
 * @export
 * @interface IntegrationSubscribe
 */
export interface IntegrationSubscribe {
    /**
     * 
     * @type {Array<IntegrationSubscribeObject>}
     * @memberof IntegrationSubscribe
     */
    objects?: Array<IntegrationSubscribeObject>;
}

/**
 * Check if a given object implements the IntegrationSubscribe interface.
 */
export function instanceOfIntegrationSubscribe(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationSubscribeFromJSON(json: any): IntegrationSubscribe {
    return IntegrationSubscribeFromJSONTyped(json, false);
}

export function IntegrationSubscribeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationSubscribe {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : ((json['objects'] as Array<any>).map(IntegrationSubscribeObjectFromJSON)),
    };
}

export function IntegrationSubscribeToJSON(value?: IntegrationSubscribe | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : ((value.objects as Array<any>).map(IntegrationSubscribeObjectToJSON)),
    };
}

